<template>
	<label
		:for="name"
		class="flex align-center text-sm font-medium text-gray-700"
	>
		{{ label }}
		<span v-if="tooltipMessage" class="pl-3 inline-flex">
			<help-tool-tip :tooltip-message="tooltipMessage" />
		</span>
	</label>
	<div class="mt-1 relative rounded-md shadow-sm">
		<span v-if="prefix" class="absolute top-[9px] left-3 sm:text-sm text-gray-500 pointer-events-none">{{prefix}}</span>
		<input
			:id="id"
			v-model.number="inputValue"
			:type="type"
			:name="name"
			:placeholder="placeholder"
			:min="minimum"
			:class="{ 'bg-yellow-150': required, 'border-red-400': errorMessage }"
			class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-1 focus:outline-none focus:ring-indigo-500 focus:border-secondary sm:text-sm"
			:style="prefixed"
			:maxlength="maxlength"
		/>
		<div
			v-if="errorMessage"
			class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
		>
			<ExclamationCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true" />
		</div>
	</div>
	<p v-show="errorMessage" class="text-red-500 text-xs mt-1">
		{{ errorMessage }}
	</p>
</template>

<script>
import { useModelWrapper } from '@/utils/modelWrapper'
import { ExclamationCircleIcon } from '@heroicons/vue/solid'

import HelpToolTip from '@/components/Common/HelpToolTip.vue'

export default {
	components: {
		ExclamationCircleIcon,
		HelpToolTip,
	},
	computed: {
      prefixed () {
        return this.prefix ? `padding-left: ${this.prefix.length + 2}ch` : '';
      }
    },
	props: {
		label: {
			type: String,
			required: true,
		},
		id: {
			type: String,
			required: false,
			default: '',
		},
		name: {
			type: String,
			required: false,
			default: '',
		},
		placeholder: {
			type: String,
			required: false,
			default: '',
		},
		type: {
			type: String,
			required: false,
			default: 'text',
		},
		minimum: {
			type: [Number, String],
			required: false,
			default: null,
		},
		maxlength: {
			type: [Number, String],
			required: false,
			default: null,
		},
		modelValue: {
			type: [String, Number],
			default: null,
		},
		errorMessage: {
			type: String,
			required: false,
			default: '',
		},
		required: {
			type: Boolean,
			required: false,
			default: false,
		},
		tooltipMessage: {
			type: String,
			required: false,
			default: '',
		},
		prefix: {
			type: String,
			required: false,
			default: ''
		}
	},
	setup(props, { emit }) {
		return {
			inputValue: useModelWrapper(props, emit, 'modelValue'),
		}
	},
}
</script>
